let baseUrl = ''
let socketUrl = ''
const license = '17983584'
let iframeUrl = ''

if (process.env.NODE_ENV === 'development') {
  baseUrl   = '/api'
  socketUrl = 'ws://127.0.0.1/websocket'
  iframeUrl = 'http://localhost:5173'
} else {
  baseUrl   = '/'
  socketUrl = '/websocket'
  iframeUrl = '/wallet'
}

export { baseUrl, socketUrl, license, iframeUrl }

